import React from 'react';
import Dialog from '@material-ui/core/Dialog';
//import DialogActions from '@material-ui/core/DialogActions';
//import DialogContent from '@material-ui/core/DialogContent';
//import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

FormDialog.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.string,
  actions: PropTypes.node,
  fullScreen: PropTypes.bool,
  enableClose: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  showOk:PropTypes.bool
};
  
export default function FormDialog(props) {
const theme = useTheme();
    const useFullScreen = useMediaQuery(theme.breakpoints.down('sm')) ;
  const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

  const Title = withStyles(styles)(props => {
    const { children, classes, onClose } = props;

  
    return (
      <MuiDialogTitle disableTypography className={classes.root}>
        <Grid container direction="row" justify="flex-start" alignItems="center"   >
         {onClose ? (
            <Grid item>
              <IconButton  color="primary" aria-label="close" onClick={onClose}>
                <CancelOutlinedIcon fontSize="large" />
              </IconButton>
            </Grid>
          ) : null} 
          <Grid item>
            <Typography variant="h6" component="div">{children}</Typography>
          </Grid>

          
        </Grid>
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles(theme => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles(theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

  return (
    <div>
      <Dialog
        open={props.open}
        fullScreen={props.fullScreen && useFullScreen}
        onClose={props.enableClose ? props.handleClose : null}
        scroll='paper'
        aria-labelledby="form-dialog-title"
      >

        <Title id="form-dialog-title" onClose={props.enableClose ? props.handleClose : null}>
          {props.title}
        </Title>

        <DialogContent dividers>
          {props.children}
        </DialogContent>
        <DialogActions>
          {props.showOk?<Button color="primary" variant="outlined" onClick={props.handleClose} > OK</Button>
          :props.actions}
          
        </DialogActions>
      </Dialog>
    </div>
  );
}